import { Moneda } from "@/shared/types/moneda"
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo"
import { Typography, TypographyProps } from "@mui/material"

export function HeaderTypography({
    transferenciaMetodo,
    children,
    ...props
}: {
    transferenciaMetodo?: TransferenciaMetodo
} & TypographyProps) {
    return <Typography variant="inherit" color={transferenciaMetodo?.hidden ? "textDisabled" : "textPrimary"} {...props}>
        {children}
    </Typography>
}

export function BodyTypography({
    transferenciaMetodo,
    moneda,
    children,
    ...props
}: {
    transferenciaMetodo?: TransferenciaMetodo,
    moneda?: Moneda
} & TypographyProps) {
    return <Typography variant="inherit" color={(moneda?.hidden || transferenciaMetodo?.hidden) ? "textDisabled" : "textPrimary"} {...props}>
        {children}
    </Typography>
}